import React from 'react'

export default function Header() {
    return (
        <header>
            <img className='header--logo' src={require (`./images/heart-card.png`) }/>
            {/* Image from riajuislam */}
            <h1 className='header--logo-title'>Blackjack</h1>
        </header>
    )
}